import gql from "graphql-tag";

export const GET_UNREAD_NOTIFICATIONS_COUNT_QUERY = gql`
  query GetUnreadNotificationsCount {
    getUnreadNotificationsCount
  }
`;
